<template>
  <div class="home">
    <!-- cover section -->
    <CoverSection @onStart="$router.push('/swipe')" />
    <!-- cars sections -->
    <AllCars />
  </div>
</template>

<script>
import {CoverSection, AllCars} from  '@/components'

export default {
  name: 'Home',
  components: {
    CoverSection,
    AllCars
  }
}
</script>

<style lang="scss">
// .home {
//   height: 100%;
// }
@media only screen and (min-width: 500px) {
  .home {
    height: 100%;
  }
}
</style>